/**
 * @generated SignedSource<<b4c0727d91b7d7124dcdc9d2f88bf14a>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ConcreteRequest } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type DirectoryViewSortEnum = "CREATION_DATE_ASC" | "CREATION_DATE_DESC" | "FAVOURITED_DATE_ASC" | "FAVOURITED_DATE_DESC" | "NAME_ASC" | "NAME_DESC";
export type DirectoryFavoriteViewsQuery$variables = {
  containerId?: string | null;
  first: number;
  q: string;
  sort?: ReadonlyArray<DirectoryViewSortEnum | null> | null;
  workspaceUuid?: string | null;
};
export type DirectoryFavoriteViewsQuery$data = {
  readonly directoryViewTql: {
    readonly __id: string;
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly name: string | null;
        readonly uuid: string | null;
        readonly " $fragmentSpreads": FragmentRefs<"DirectoryFavoriteViewButton" | "DirectoryManageViewDialog">;
      } | null;
    } | null> | null;
    readonly " $fragmentSpreads": FragmentRefs<"DefaultViewApplier_data">;
  } | null;
};
export type DirectoryFavoriteViewsQuery = {
  response: DirectoryFavoriteViewsQuery$data;
  variables: DirectoryFavoriteViewsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "containerId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "first"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "q"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "sort"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "workspaceUuid"
},
v5 = {
  "kind": "Variable",
  "name": "containerId",
  "variableName": "containerId"
},
v6 = {
  "kind": "Variable",
  "name": "q",
  "variableName": "q"
},
v7 = {
  "kind": "ScalarField",
  "name": "uuid"
},
v8 = {
  "kind": "ScalarField",
  "name": "name"
},
v9 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v10 = {
  "kind": "ScalarField",
  "name": "cursor"
},
v11 = {
  "concreteType": "PageInfo",
  "kind": "LinkedField",
  "name": "pageInfo",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "endCursor"
    },
    {
      "kind": "ScalarField",
      "name": "hasNextPage"
    }
  ]
},
v12 = {
  "kind": "ClientExtension",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "__id"
    }
  ]
},
v13 = [
  (v5/*: any*/),
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "first"
  },
  (v6/*: any*/),
  {
    "kind": "Variable",
    "name": "sort",
    "variableName": "sort"
  },
  {
    "kind": "Variable",
    "name": "workspaceUuid",
    "variableName": "workspaceUuid"
  }
],
v14 = {
  "kind": "ScalarField",
  "name": "id"
},
v15 = [
  {
    "kind": "ScalarField",
    "name": "aaid"
  },
  {
    "concreteType": "UserPII",
    "kind": "LinkedField",
    "name": "pii",
    "plural": false,
    "selections": [
      (v8/*: any*/),
      {
        "kind": "ScalarField",
        "name": "picture"
      }
    ]
  },
  (v14/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/)
    ],
    "kind": "Fragment",
    "name": "DirectoryFavoriteViewsQuery",
    "selections": [
      {
        "alias": "directoryViewTql",
        "args": [
          (v5/*: any*/),
          (v6/*: any*/)
        ],
        "concreteType": "DirectoryViewConnection",
        "kind": "LinkedField",
        "name": "__DirectoryFavoriteViews_directoryViewTql_connection",
        "plural": false,
        "selections": [
          {
            "kind": "FragmentSpread",
            "name": "DefaultViewApplier_data"
          },
          {
            "concreteType": "DirectoryViewEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "concreteType": "DirectoryView",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  (v7/*: any*/),
                  (v8/*: any*/),
                  {
                    "kind": "FragmentSpread",
                    "name": "DirectoryFavoriteViewButton"
                  },
                  {
                    "kind": "FragmentSpread",
                    "name": "DirectoryManageViewDialog"
                  },
                  (v9/*: any*/)
                ]
              },
              (v10/*: any*/)
            ]
          },
          (v11/*: any*/),
          (v12/*: any*/)
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v2/*: any*/),
      (v1/*: any*/),
      (v4/*: any*/),
      (v0/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Operation",
    "name": "DirectoryFavoriteViewsQuery",
    "selections": [
      {
        "args": (v13/*: any*/),
        "concreteType": "DirectoryViewConnection",
        "kind": "LinkedField",
        "name": "directoryViewTql",
        "plural": false,
        "selections": [
          {
            "concreteType": "DirectoryViewEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "concreteType": "DirectoryView",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  (v7/*: any*/),
                  {
                    "kind": "ScalarField",
                    "name": "isDefault"
                  },
                  (v14/*: any*/),
                  (v8/*: any*/),
                  {
                    "kind": "ScalarField",
                    "name": "isFavourite"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "entityType"
                  },
                  {
                    "concreteType": "User",
                    "kind": "LinkedField",
                    "name": "creator",
                    "plural": false,
                    "selections": (v15/*: any*/)
                  },
                  {
                    "concreteType": "User",
                    "kind": "LinkedField",
                    "name": "lastEditedBy",
                    "plural": false,
                    "selections": (v15/*: any*/)
                  },
                  {
                    "kind": "ScalarField",
                    "name": "creationDate"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "lastEditedDate"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "favouriteCount"
                  },
                  (v9/*: any*/)
                ]
              },
              (v10/*: any*/)
            ]
          },
          (v11/*: any*/),
          (v12/*: any*/)
        ]
      },
      {
        "args": (v13/*: any*/),
        "filters": [
          "q",
          "containerId"
        ],
        "handle": "connection",
        "key": "DirectoryFavoriteViews_directoryViewTql",
        "kind": "LinkedHandle",
        "name": "directoryViewTql"
      }
    ]
  },
  "params": {
    "cacheID": "6ae00e6a6540c3060f342bd850a9f6be",
    "id": null,
    "metadata": {
      "connection": [
        {
          "count": "first",
          "cursor": null,
          "direction": "forward",
          "path": [
            "directoryViewTql"
          ]
        }
      ]
    },
    "name": "DirectoryFavoriteViewsQuery",
    "operationKind": "query",
    "text": "query DirectoryFavoriteViewsQuery(\n  $q: String!\n  $first: Int!\n  $workspaceUuid: UUID\n  $containerId: String\n  $sort: [DirectoryViewSortEnum]\n) {\n  directoryViewTql(q: $q, first: $first, workspaceUuid: $workspaceUuid, containerId: $containerId, sort: $sort) {\n    ...DefaultViewApplier_data\n    edges {\n      node {\n        uuid\n        name\n        ...DirectoryFavoriteViewButton\n        ...DirectoryManageViewDialog\n        id\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n\nfragment DefaultViewApplier_data on DirectoryViewConnection {\n  edges {\n    node {\n      uuid\n      isDefault\n      id\n    }\n  }\n}\n\nfragment DeleteDirectoryViewModal on DirectoryView {\n  name\n  uuid\n  isFavourite\n  favouriteCount\n}\n\nfragment DirectoryFavoriteViewButton on DirectoryView {\n  id\n  uuid\n  name\n  isFavourite\n  entityType\n  ...DirectoryManageViewDialog\n}\n\nfragment DirectoryManageViewDialog on DirectoryView {\n  name\n  entityType\n  isFavourite\n  isDefault\n  uuid\n  creator {\n    aaid\n    pii {\n      name\n      picture\n    }\n    id\n  }\n  lastEditedBy {\n    aaid\n    pii {\n      name\n      picture\n    }\n    id\n  }\n  creationDate\n  lastEditedDate\n  ...RenameDirectoryViewModal\n  ...DeleteDirectoryViewModal\n}\n\nfragment RenameDirectoryViewModal on DirectoryView {\n  name\n  uuid\n}\n"
  }
};
})();

(node as any).hash = "ec1c2208b8aec68d6c50cc5ba76c0f9a";

export default node;
